import { inject } from 'vue';
import { projectSeriesKey } from '../keys';

export function useProjectSeriesInjection() {
    const projectSeriesInjection = inject(projectSeriesKey);
    if (!projectSeriesInjection) {
        throw new Error('Project series not properly injected');
    }
    return projectSeriesInjection;
}
